"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenService = void 0;
var token_1 = require("./firmachain/token");
var FirmaUtil_1 = require("./FirmaUtil");
var TokenService = /** @class */ (function () {
    function TokenService(config) {
        this.config = config;
    }
    TokenService.prototype.getGasEstimationCreateToken = function (wallet, tokenName, tokenSymbol, tokenURI, totalSupply, decimal, isMintable, isBurnable, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var newTotalSupply, txRaw, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        newTotalSupply = FirmaUtil_1.FirmaUtil.getUTokenFromToken(totalSupply, decimal);
                        return [4 /*yield*/, this.getSignedTxCreateToken(wallet, tokenName, tokenSymbol, tokenURI, newTotalSupply, decimal, isMintable, isBurnable, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getGasEstimationMint = function (wallet, tokenID, amount, decimal, toAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var newAmount, txRaw, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        newAmount = FirmaUtil_1.FirmaUtil.getUTokenFromToken(amount, decimal);
                        return [4 /*yield*/, this.getSignedTxMint(wallet, tokenID, amount, toAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getGasEstimationBurn = function (wallet, tokenID, amount, decimal, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var newAmount, txRaw, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        newAmount = FirmaUtil_1.FirmaUtil.getUTokenFromToken(amount, decimal);
                        return [4 /*yield*/, this.getSignedTxBurn(wallet, tokenID, newAmount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getGasEstimationUpdateTokenURI = function (wallet, tokenID, tokenURI, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxUpdateTokenURI(wallet, tokenID, tokenURI, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        return [4 /*yield*/, FirmaUtil_1.FirmaUtil.estimateGas(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_4 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getSignedTxUpdateTokenURI = function (wallet, tokenID, tokenURI, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, txClient, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = token_1.TokenTxClient.msgUpdateTokenURI({
                            owner: address,
                            tokenID: tokenID,
                            tokenURI: tokenURI
                        });
                        txClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_5 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_5);
                        throw error_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getSignedTxBurn = function (wallet, tokenID, amount, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, txClient, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = token_1.TokenTxClient.msgBurn({
                            owner: address,
                            tokenID: tokenID,
                            amount: amount
                        });
                        txClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_6);
                        throw error_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getSignedTxMint = function (wallet, tokenID, amount, toAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, txClient, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = token_1.TokenTxClient.msgMint({
                            owner: address,
                            tokenID: tokenID,
                            amount: amount,
                            toAddress: toAddress
                        });
                        txClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_7);
                        throw error_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getSignedTxCreateToken = function (wallet, tokenName, tokenSymbol, tokenURI, totalSupply, decimal, isMintable, isBurnable, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var address, message, txClient, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, wallet.getAddress()];
                    case 1:
                        address = _a.sent();
                        message = token_1.TokenTxClient.msgCreateToken({
                            owner: address,
                            name: tokenName,
                            symbol: tokenSymbol,
                            tokenURI: tokenURI,
                            totalSupply: totalSupply,
                            decimal: decimal,
                            mintable: isMintable,
                            burnable: isBurnable
                        });
                        txClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, txClient.sign([message], FirmaUtil_1.getSignAndBroadcastOption(this.config.denom, txMisc))];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    //./firmachaind tx token mint ukai 1000000 firma1jmg3kwy5hntx66nl93dyk2d92943394qsf6gcf  --from alice --fees 2000ufct --chain-id imperium-2
    TokenService.prototype.createToken = function (wallet, tokenName, tokenSymbol, tokenURI, totalSupply, decimal, isMintable, isBurnable, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var newTotalSupply, txRaw, nftTxClient, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        newTotalSupply = FirmaUtil_1.FirmaUtil.getUTokenFromToken(totalSupply, decimal);
                        return [4 /*yield*/, this.getSignedTxCreateToken(wallet, tokenName, tokenSymbol, tokenURI, newTotalSupply, decimal, isMintable, isBurnable, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        nftTxClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.mint = function (wallet, tokenID, amount, decimal, toAddress, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var newAmount, txRaw, nftTxClient, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        newAmount = FirmaUtil_1.FirmaUtil.getUTokenFromToken(amount, decimal);
                        return [4 /*yield*/, this.getSignedTxMint(wallet, tokenID, newAmount, toAddress, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        nftTxClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_10 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.burn = function (wallet, tokenID, amount, decimal, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var newAmount, txRaw, nftTxClient, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        newAmount = FirmaUtil_1.FirmaUtil.getUTokenFromToken(amount, decimal);
                        return [4 /*yield*/, this.getSignedTxBurn(wallet, tokenID, newAmount, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        nftTxClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_11 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.updateTokenURI = function (wallet, tokenID, tokenURI, txMisc) {
        if (txMisc === void 0) { txMisc = FirmaUtil_1.DefaultTxMisc; }
        return __awaiter(this, void 0, void 0, function () {
            var txRaw, nftTxClient, error_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getSignedTxUpdateTokenURI(wallet, tokenID, tokenURI, txMisc)];
                    case 1:
                        txRaw = _a.sent();
                        nftTxClient = new token_1.TokenTxClient(wallet, this.config.rpcAddress);
                        return [4 /*yield*/, nftTxClient.broadcast(txRaw)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_12 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_12);
                        throw error_12;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    //  query
    TokenService.prototype.getTokenDataAll = function (paginationKey) {
        if (paginationKey === void 0) { paginationKey = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, error_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new token_1.TokenQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryTokenDataAll(paginationKey)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_13 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_13);
                        throw error_13;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getTokenData = function (tokenID) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, tokenData, error_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new token_1.TokenQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryTokenData(tokenID)];
                    case 1:
                        tokenData = _a.sent();
                        return [2 /*return*/, tokenData];
                    case 2:
                        error_14 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_14);
                        throw error_14;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TokenService.prototype.getTokenDataListFromOwner = function (ownerAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var queryClient, tokenData, error_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        queryClient = new token_1.TokenQueryClient(this.config.restApiAddress);
                        return [4 /*yield*/, queryClient.queryTokenDataFromOwner(ownerAddress)];
                    case 1:
                        tokenData = _a.sent();
                        return [2 /*return*/, tokenData];
                    case 2:
                        error_15 = _a.sent();
                        FirmaUtil_1.FirmaUtil.printLog(error_15);
                        throw error_15;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return TokenService;
}());
exports.TokenService = TokenService;
